import * as R from 'ramda'
import slugify from '@sindresorhus/slugify'
import { notNilOrEmpty, getYoutubeUrlId, mapIndexed } from '../lib/Helpers'
import { testimonialRelations } from '../sanity/fragments/testimonials'

export default class Testimonial {
  constructor(testimonial, sanityClient) {
    this.sanityClient = sanityClient
    this.testimonial = { ...testimonial }
  }

  isNew() {
    return !this.testimonial._id
  }

  toCreate() {
    const slug = `${slugify(
      this.testimonial.title
    )}-${new Date().getTime().toString(36)}`

    const validation = {}

    return {
      _id: `drafts.${slug}`,
      _type: 'testimonials',
      title: this.testimonial.title,
      city: this.testimonial.city,
      state: this.testimonial.state,
      email: this.testimonial.email,
      story: this.testimonial.story,
      video: getYoutubeUrlId(this.testimonial.video),
      categories: {
        _ref: this.testimonial.category,
        _key: this.testimonial.category,
        _type: 'reference',
      },
      slug: {
        type: 'slug',
        current: slug,
      },
      ...validation,
    }
  }

  async createTestimonial() {
    console.log(this.testimonial)
    try {
      const doc = this.toCreate()
      const newTestimonial = await this.sanityClient.create(doc)
      if (this.testimonial.profile_img) {
        await this.sanityClient.assets
          .upload('image', this.testimonial.profile_img, {
            filename: this.testimonial.profile_img.name,
          })
          .then((imageAsset) => {
            return this.sanityClient
              .patch(newTestimonial._id)
              .set({
                profile_img: {
                  _type: 'image',
                  asset: {
                    _type: 'reference',
                    _ref: imageAsset._id,
                  },
                },
              })
              .commit()
          })
      }
      return this.getLatestDocument(newTestimonial._id)
    } catch (error) {
      throw error
    }
  }

  async getLatestDocument(id) {
    const results = await this.sanityClient
      .fetch(`*[_id == "${id}"]${testimonialRelations}`)
      .catch((reason) => {
        // Track the reason here
        console.log(reason)
        if (typeof window !== 'undefined') {
          window.alert(
            'Failed to fetch an exhibitor record for your account, our service might be down, apologies for the inconvenience.'
          )
        }
      })
    // console.log('RESULTS', results)
    return results[0]
  }
}
